<template>
  <div class="rb-ob-form rb-match-page rb-book-page rb-pay-page rb-consent-page">
    <header>
      <h1 class="rb-ob-title">{{ $t('intake.clientHomeTitle') }}</h1>
    </header>

    <div class="rb-ob-status-panel">
      <p class="rb-match-outcome-body">{{ bodyText }}</p>
      <p v-if="doctorName" class="rb-match-outcome-body">{{ doctorLine }}</p>
      <p v-if="hasRematchOffer" class="rb-match-outcome-body">{{ $t('intake.rematchOfferReason') }}</p>
      <p v-if="hasRematchSafetyReview" class="rb-match-outcome-body">{{ $t('intake.rematchSafetyReviewPending') }}</p>
      <p v-if="hasRematchValueReview" class="rb-match-outcome-body">{{ $t('intake.rematchValueReviewPending') }}</p>
      <router-link v-if="hasRematchValueReview || hasRematchSafetyReview || canContinueRematch" class="rb-ob-submit" :to="{name:'intakeRematchRun',params:{lang:$route.params.lang || 'fa'}}">{{ $t('intake.rematchCheckStatusAction') }}</router-link>
    </div>

    <div class="rb-ob-actions">
      <button class="rb-ob-submit" type="button" :disabled="loading" @click="enter">
        {{ $t('intake.clientHomeCta') }}
      </button>
      <button v-if="hasRematchOffer" class="rb-ob-submit rb-ob-submit-secondary" type="button" :disabled="loading" @click="openRematch">{{ $t('intake.rematchAcceptAction') }}</button>
      <button
          v-if="hasDoctor"
          class="rb-ob-submit rb-ob-submit-secondary"
          type="button"
          :disabled="loading"
          @click="goPortal"
      >
        {{ $t('intake.clientHomePortalCta') }}
      </button>
      <p class="rb-ob-status" role="status" aria-live="polite">{{ statusText }}</p>
      <div class="rb-ob-trust">
        <p>{{ $t('intake.trustPath') }}</p>
        <p>{{ $t('authUi.familyNote') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import {
  doctorDisplayName,
  fetchProfile,
  resolveDoctor,
  fetchActiveCare,
  fetchCareClinicalResponse,
} from '@/intake/portalApi'

export default {
  name: 'MatchClientHomeStep',
  data() {
    return {
      loading: true,
      profile: null,
      care: null,
      statusText: '',
      clinical: null,
    }
  },
  computed: {
    lang() {
      return this.$route.params.lang || 'fa'
    },
    doctor() {
      return resolveDoctor(this.profile)
    },
    hasDoctor() {
      return !!this.doctor
    },
    doctorName() {
      return doctorDisplayName(this.doctor, this.lang)
    },
    rematchStatus() { return this.clinical && this.clinical.rematch ? this.clinical.rematch.status : '' },
    hasRematchOffer() { return this.rematchStatus === 'OFFERED' },
    hasRematchSafetyReview() { return this.rematchStatus === 'SAFETY_APPROVAL_REQUIRED' },
    hasRematchValueReview() { return ['MANUAL_REVIEW_REQUIRED', 'FINANCIAL_RESOLUTION_REQUIRED'].includes(this.rematchStatus) },
    canContinueRematch() { return ['ACCEPTED_PENDING_REQUIREMENTS','MATCH_FAILED','MATCH_READY','NO_SUPPLY'].includes(this.rematchStatus) },
    doctorLine() {
      if (!this.doctorName) return ''
      return this.$t('intake.clientHomeDoctor', {name: this.doctorName})
    },
    bodyText() {
      if (this.hasDoctor) return this.$t('intake.clientHomeBodyMatched')
      return this.$t('intake.clientHomeBody')
    },
  },
  mounted() {
    this.bootstrap()
  },
  methods: {
    bootstrap() {
      this.loading = true
      fetchProfile()
          .then((profile) => {
            this.profile = profile
            return fetchActiveCare().catch(() => null)
          })
          .then((care) => {
            this.care = care
            return care && care.id ? fetchCareClinicalResponse(care.id).catch(() => null) : null
          })
          .then((clinical) => { this.clinical = clinical })
          .catch(() => {
            this.statusText = this.$t('intake.portal.loadError')
          })
          .finally(() => {
            this.loading = false
          })
    },
    enter() {
      const ready = !!(this.care && this.care.first_session_operational_readiness && this.care.first_session_operational_readiness.state === 'READY')
      this.$router.push({
        name: ready ? 'intakeReadyOk' : 'intakeReadyLock',
        params: {lang: this.lang},
        query: this.$route.query,
      })
    },
    openRematch() { this.$router.push({name: 'intakeRematchOffer', params: {lang: this.lang}}) },
    goPortal() {
      this.$router.push({
        name: 'portalHome',
        params: {lang: this.lang},
      })
    },
  },
}
</script>
